/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../shared/store/auth-Slice";
import { CheckEye, Eye, Warn } from "../../../components/common/svg/AllSvg";
import SecondaryBtn from "../../../components/common/form/SecondaryBtn";
import { useNavigate, useParams } from "react-router-dom";
import Captcha from "../../../components/common/form/Captcha";
import { storeCookie } from "../../../shared/utils/storeCookie";
import { Bounce, ToastContainer } from "react-toastify";
import { errors } from "../../../shared/utils/errors";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import { dataActions } from "../../../shared/store/data-Slice";
import { languages } from "../../../shared/utils/languages";
import { uiActions } from "../../../shared/store/ui-Slice";

const Login = () => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [hide, setHide] = useState<boolean>(true);
  const [submit, setSubmit] = useState<boolean>(false);
  const [passFcs, setPassFcs] = useState<boolean>(false);
  const [remember, setRemember] = useState<boolean>(false);
  const { i18n, t } = useTranslation('common');
  const [captchaValue, setCaptchaValue] = useState<string>("")
  const [captchaError, setCaptchaError] = useState<string>("")
  const [captchaExpirationTime, setCaptchaExpirationTime] = useState(Date.now() + (5 * 60 * 1000));
  const [captchaInput, setCaptchaInput] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  useSitemap();

  useEffect(() => {
    if (!!params?.lang) {
      if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
        let obj: any = languages?.find((item: any) => item?.value === params?.lang);

        if (!!obj && Object?.keys(obj)?.length > 0) {
          i18n.changeLanguage(obj?.value);
          dispatch(uiActions.changeLang(obj?.value));
        } else {
          i18n.changeLanguage("en");
          dispatch(uiActions.changeLang("en"));
        }
      } else {
        navigate("/en")
      }
    } else {
      i18n.changeLanguage("en");
      dispatch(uiActions.changeLang("en"));
    }
  }, [params?.lang])

  const handlePassword = () => {
    setHide(!hide);
  };

  const formik: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: yup.object().shape({
      email: yup.string().email(t("auth.form.validation.wrong_email")).required(t("auth.form.validation.email")),
      password: yup.string().required(t("auth.form.validation.password")),
    }),
    onSubmit: async (values: any) => {
      //submit
      try {
        //submit
        if (!!!captchaValue) {
          setCaptchaError(t("auth.form.validation.captcha"))
          return;
        }

        if (captchaInput !== captchaValue) {
          setCaptchaError(t("auth.form.validation.match_captcha"));
          return;
        }

        setSubmit(true)
        let obj = {
          username: values.email,
          password: values.password,
        }
        const res: any = await useAxios.post(`/${(!!lang ? lang : "en") + url?.login}`, obj);

        if (res && res?.status === 200) {
          dispatch(authActions.login());
          let sessionTimeout: any = (new Date().getTime() + (86400000));
          dispatch(authActions.userDetail(res?.data?.data))
          storeCookie(res?.data, sessionTimeout)
          setSubmit(false)
          !!params?.lang ? navigate(`/${params?.lang}`) : navigate(`/`)
        }
      } catch (error: any) {
        errors(error)
        setSubmit(false)
        console.error("error while login", error);
      }
    }
  });

  return (
    <div className="w-full h-full relative min-h-screen">
      <Canonical />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className="h-full min-h-screen w-full">
        <div className="container md:grid md:grid-cols-2 gap-[40px] flex md:flex-row flex-col py-[40px] xlx:py-0 h-full min-h-screen">
          <div className="w-full flex md:items-center justify-center flex-col h-fit md:h-full md:order-1 order-2">
            <form className="flex flex-col w-full msm:w-[400px] relative z-[1]">
              <h2 className="text-primaryText font-bold">{t("grievance.auth.title")}</h2>
              <h6 className="text-[#636D7E] font-normal">{t("grievance.auth.desc")}</h6>

              <div className="flex flex-col gap-[18px] pt-[20px] xlx:pt-[24px] w-full">
                <div className="flex flex-col gap-[4px]">
                  <h6 className="text-blackDark font-medium">{t("auth.form.field.email")}</h6>
                  <input className="placeholder:text-blackDull rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug" type="email" name="email" placeholder={t("auth.form.field.email")} value={formik?.values?.email} onBlur={formik?.handleBlur} onChange={formik?.handleChange} autoComplete="off" />
                  {formik?.touched?.email && formik?.errors?.email && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger text-xs font-medium">{formik?.errors?.email}</span>
                  </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                  <h6 className="text-blackDark font-medium">{t("auth.form.field.password")}</h6>
                  <div className={`rounded-[6px] border border-[#D7D8DD] h-[35px] xlx:h-[40px] w-full relative flex items-center ${passFcs ? "bg-white" : "hover:bg-white bg-[#F5F5F5]"}`}>
                    <input className="placeholder:text-blackDull rounded-[6px] bg-transparent w-full text-blackDull text-sm leading-snug h-full pl-[15px] xlx:pl-[17px] pr-[40px]" type={hide ? "password" : "text"} name="password" placeholder={t("auth.form.field.password")} value={formik?.values?.password} onBlur={(e: any) => { formik?.handleBlur(e); setPassFcs(false) }} onChange={formik?.handleChange} autoComplete="off" onFocus={() => setPassFcs(true)} />

                    <button type="button" className="absolute right-[10px] cursor-pointer h-full" onClick={handlePassword}>
                      {hide ? <CheckEye /> : <Eye />}
                    </button>
                  </div>
                  {formik?.touched?.password && formik?.errors?.password && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger text-xs font-medium">{formik?.errors?.password}</span>
                  </div>}
                </div>
              </div>

              <div className="flex w-full items-center justify-between pt-[15px]">
                <div className="flex items-center gap-[8px]">
                  <input id="default-checkbox" type="checkbox" checked={remember} onChange={() => setRemember(!remember)} className="w-[16px] h-[16px] rounded-[5px] hover:ring-primary focus:ring-primary hover:ring-1 focus:ring-1" />
                  <h6 className="text-primaryText font-medium">{t("grievance.auth.remember_me")}</h6>
                </div>
                <button className="text-blackDull text-sm leading-snug font-normal hover:underline focus:underline" type="button" onClick={() => dispatch(dataActions.setResetPasswordOpen(true))}>{t("auth.forgot_password")}</button>
              </div>

              <div className="flex flex-col pt-[20px] xlx:pt-[40px]">
                <Captcha captchaValue={captchaValue} setCaptchaValue={setCaptchaValue} captchaError={captchaError} setCaptchaError={setCaptchaError} captchaExpirationTime={captchaExpirationTime} setCaptchaExpirationTime={setCaptchaExpirationTime} captchaInput={captchaInput} setCaptchaInput={setCaptchaInput} />
              </div>

              <SecondaryBtn title={t("auth.loginBtn")} css="w-full flex items-center justify-center uppercase !rounded-[6px] mt-[40px] font-bold" onClick={formik?.handleSubmit} disabled={submit} />

              {/* <div className="flex items-center justify-center w-full pt-[15px]">
              <div className="text-[#606060] text-sm leading-snug font-normal">{t("auth.no_account")} &nbsp;<button className="text-primary text-sm leading-snug font-semibold focus:underline hover:underline" type="button" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/register`) : navigate(`/register`)}>{t("auth.register")}</button></div>
            </div> */}
            </form>
          </div>
          <div className="w-full flex items-center justify-center h-fit md:h-full md:order-2 order-1 relative z-[1]">
            <div className="relative">
              <img src={require("../../../assets/images/chatbot-login.png")} alt="login-img" />

              <div className="absolute left-0 bottom-0 p-[25px] xlx:px-[40px] xlx:py-[30px] flex flex-col gap-[4px]">
                <h1 className="font-bold text-primary">{t("chatbot.auth.img_title")}</h1>
                <h5 className="font-medium text-blackDull max-w-[355px] xlx:max-w-[419px]">{t("chatbot.auth.img_desc")}</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0">
          <img src={require("../../../assets/images/grievance-pattern1.png")} alt="pattern" />
        </div>
      </div>
    </div>
  );
};

export default Login;